export enum MatchType {
  HEAD_TO_HEAD = 1,
  OUTRIGHT = 2,
}

export const enum MatchClass {
  ORDINARY = 0,
  INTERESTING_MATCH = 1,
  MATCH_OF_THE_DAY = 2,
  TOP_MATCH = 3,
}

export const enum MatchStatus {
  NOT_STARTED = 1,
  IN_PROGRESS = 2,
  MATCH_FINISHED = 3,
}

export enum SlotType {
  PREMATCH = 1,
  LIVE = 2,
}

// --- SCORES TYPE ---
// https://confluence.tennisi.it/pages/viewpage.action?pageId=754286894

export type MatchScoreType =
  SoccerScoreType | TennisScoreType | TableTennisScoreType | BoxingScoreType |
  MMAScoreType | AUFootballScoreType | BasketballScoreType | IceHockeyScoreType |
  USFootballScoreType | BaseballScoreType | HandballScoreType | RugbyUnionScoreType |
  RugbyLeagueScoreType | FloorballScoreType | HockeyWithBallScoreType | FieldHockeyScoreType |
  FutsalScoreType | VolleyballScoreType | BeachVolleyballScoreType | DartsScoreType |
  SnookerScoreType | WaterPoloScoreType | BeachFootballScoreType | NetballScoreType |
  GolfScoreType | BadmintonScoreType | CricketScoreType | ESportsScoreType |
  HorseRacingScoreType | RaceScoreType | CyclingScoreType | PesapalloScoreType;

export enum SoccerScoreType {
  GOAL = 100,
  YELLOW_CARD = 101,
  RED_CARD = 102,
  CORNER = 103,
  OFFSIDE = 104,
  FOUL = 105,
  KICK = 106,
}
export enum TennisScoreType {
  POINT = 200,
  ACE = 201,
  DOUBLE_FAULT = 202,
}
export enum TableTennisScoreType {
  POINT = 300,
  SET = 301,
}
export enum BoxingScoreType {
  POINT = 400,
}
export enum MMAScoreType {
  POINT = 500,
}
export enum AUFootballScoreType { // Australian Football
  GOAL = 600,
  INSIDE_GATE_GOAL = 601,
}
export enum BasketballScoreType {
  POINT = 700,
  FREE_SINGLE_POINT = 701,
  FREE_DOUBLE_POINT = 702,
  FREE_TRIPLE_POINT = 703,
  THROW_SINGLE_POINT = 704,
  THROW_DOUBLE_POINT = 705,
  THROW_TRIPLE_POINT = 706,
  SELECTION = 707,
  TRANSFER = 709,
  LOSS = 710,
  INTERCEPT = 711,
  BLOCK = 712,
}
export enum IceHockeyScoreType {
  GOAL = 800,
  BULLET = 801,
  REMOVAL_2_MIN = 802,
  REMOVAL_5_MIN = 803,
  REMOVAL_10_MIN = 804,
  REMOVAL_20_MIN = 805,
  REMOVAL_25_MIN = 806,
  THROW = 807,
  THROW_IN = 808,
  POWER_RECEPTION = 809,
}
export enum USFootballScoreType { // American Football
  GOAL = 900,
}
export enum BaseballScoreType {
  POINT = 1000,
  FOUL = 1001,
}
export enum HandballScoreType {
  GOAL = 1100,
}
export enum RugbyUnionScoreType {
  GOAL = 1200,
}
export enum RugbyLeagueScoreType {
  GOAL = 1300,
}
export enum FloorballScoreType {
  GOAL = 1400,
}
export enum HockeyWithBallScoreType {
  GOAL = 1500,
}
export enum FieldHockeyScoreType {
  GOAL = 1600,
}
export enum FutsalScoreType {
  GOAL = 1700,
}
export enum VolleyballScoreType {
  POINT = 1800,
  ACE = 1801,
  BLOCK = 1802,
  PITCH_MISTAKE = 1803,
}
export enum BeachVolleyballScoreType {
  POINT = 1900,
}
export enum DartsScoreType {
  POINT = 2000,
}
export enum SnookerScoreType {
  POINT = 2100,
}
export enum WaterPoloScoreType {
  GOAL = 2200,
}
export enum BeachFootballScoreType {
  GOAL = 2300,
}
export enum NetballScoreType {
  GOAL = 2400,
}
export enum GolfScoreType {
  PAR = 2500,
}
export enum BadmintonScoreType {
  POINT = 2600,
}
export enum CricketScoreType {
  WOUNDS = 2700,
  GATE_BROKEN = 2701,
}
export enum ESportsScoreType {
  MAP = 2800,
  POINT = 2801,
}
export enum HorseRacingScoreType {
  PLACE = 2900,
}
export enum RaceScoreType {
  POINT = 3000,
}
export enum CyclingScoreType {
  POINT = 3100,
}
export enum PesapalloScoreType {
  POINT = 3200,
}

// --- PERIODS TYPE ---
// https://confluence.tennisi.it/pages/viewpage.action?pageId=754286898

export type MatchPeriodType =
  SoccerPeriodType | TennisPeriodType | TableTennisPeriodType | BasketballPeriodType |
  IceHockeyPeriodType | HandballPeriodType | RugbyUnionPeriodType | HockeyWithBallPeriodType |
  FieldHockeyPeriodType | FutsalPeriodType | VolleyballPeriodType | BeachVolleyballPeriodType |
  WaterPoloPeriodType | BadmintonPeriodType | ESportsPeriodType;

export enum SoccerPeriodType {
  MATCH = 100,
  TIME = 101,
  COMPENSATED_TIME = 102,
  PENALTY = 103,
  EXTRA_TIME = 104,
  BREAK = 105,
  MAIN_TIME = 106,
  ALL_COMPENSATED_TIME = 107,
}
export enum TennisPeriodType {
  MATCH = 200,
  SET = 201,
  GAME = 202,
}
export enum TableTennisPeriodType {
  MATCH = 300,
  SET = 301,
}
export enum BasketballPeriodType {
  MATCH = 700,
  QUARTER = 701,
  HALF = 702,
  OVERTIME = 703,
  BREAK = 704,
  // TODO: в доке нет такого ключа, но в старых константах есть
  // Нужно узнать, нужен ли этот ключ
  TIMEOUT = 705,
  MAIN_TIME = 706,
  ALL_COMPENSATED_TIME = 707,
}
export enum IceHockeyPeriodType {
  MATCH = 800,
  PERIOD = 801,
  OVERTIME = 802,
  BULLET = 803,
  BREAK = 804,
  TIMEOUT = 805,
  MAIN_TIME = 806,
}
export enum HandballPeriodType {
  MATCH = 1100,
  TIME = 1101,
  PENALTY = 1102,
  COMPENSATED_TIME = 1103,
  BREAK = 1104,
  MAIN_TIME = 1105,
  ALL_COMPENSATED_TIME = 1106,
}
export enum RugbyUnionPeriodType {
  MATCH = 1200,
  TIME = 1201,
  COMPENSATED_TIME = 1202,
  BREAK = 1203,
  MAIN_TIME = 1204,
  BULLET = 1205,
  ALL_COMPENSATED_TIME = 1206,
}
export enum HockeyWithBallPeriodType {
  MATCH = 1500,
  TIME = 1501,
  COMPENSATED_TIME = 1503,
  BREAK = 1504,
  MAIN_TIME = 1505,
}
export enum FieldHockeyPeriodType {
  MATCH = 1600,
  SET = 1601,
  COMPENSATED_TIME = 1602,
  BULLET = 1603,
  BREAK = 1604,
  MAIN_TIME = 1605,
}
export enum FutsalPeriodType {
  MATCH = 1700,
  TIME = 1701,
  PENALTY = 1703,
  COMPENSATED_TIME = 1704,
  BREAK = 1705,
  MAIN_TIME = 1706,
  ALL_COMPENSATED_TIME = 1707,
}
export enum VolleyballPeriodType {
  MATCH = 1800,
  SET = 1801,
  BREAK = 1802,
}
export enum BeachVolleyballPeriodType {
  MATCH = 1900,
  SET = 1901,
}
export enum WaterPoloPeriodType {
  MATCH = 2200,
  PERIOD = 2201,
  BREAK = 2203,
  TIMEOUT = 2204,
  BULLET = 2205,
}
export enum BadmintonPeriodType {
  MATCH = 2600,
  SET = 2601,
}

export enum ESportsPeriodType {
  MATCH = 2800,
  MAP = 2801,
}
